var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 23.3333C19.8333 21.4003 17.2217 19.8333 14 19.8333C10.7783 19.8333 8.16667 21.4003 8.16667 23.3333M24.5 19.8332C24.5 18.398 23.0602 17.1645 21 16.6244M3.5 19.8332C3.5 18.398 4.93978 17.1645 7 16.6244M21 11.9421C21.716 11.3013 22.1667 10.3699 22.1667 9.33334C22.1667 7.40035 20.5997 5.83334 18.6667 5.83334C17.7703 5.83334 16.9525 6.17034 16.3333 6.72455M7 11.9421C6.28396 11.3013 5.83333 10.3699 5.83333 9.33334C5.83333 7.40035 7.40034 5.83334 9.33333 5.83334C10.2297 5.83334 11.0475 6.17034 11.6667 6.72455M14 16.3333C12.067 16.3333 10.5 14.7663 10.5 12.8333C10.5 10.9003 12.067 9.33334 14 9.33334C15.933 9.33334 17.5 10.9003 17.5 12.8333C17.5 14.7663 15.933 16.3333 14 16.3333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user_group.7cd2e643d18bccd56accbd439c56d8c8.svg";
export { ForwardRef as ReactComponent };